import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { LuPencilLine } from "react-icons/lu";
import ContestTypeForm from "./contestTypeForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  addContestType,
  deleteContestType,
  editContestType,
  getContestType,
  getSingleContestType,
} from "../../redux/services/contestTypeSlice";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import Table from "../../common/Table";
import { exportToTablePDF } from "../../common/PdfFormat";

const ContestType = () => {
  const dispatch = useDispatch();
  const getContestData = useSelector(
    (state) => state?.contestType?.contestTypeData
  );
  const getSingleContestData = useSelector(
    (state) => state?.contestType?.singleContestTypeData
  );
  const [modelOpen, setModelOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [editId, setEditId] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const initialValues = {
    name: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Contest Type  is required"),
  });
  const getAllContest = useCallback(async () => {
    try {
      await dispatch(
        getContestType({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllContest();
  }, [getAllContest]);
  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };

    if (editId) {
      payload.contestTypeId = editId;
    }
    try {
      let response;
      if (editId) {
        response = await dispatch(editContestType(payload));
      } else {
        response = await dispatch(addContestType(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        setModelOpen(false);
        resetForm();
        getAllContest();
      }
    } catch (error) {}
    setModelOpen(false);
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const deleteContestData = async () => {
    try {
      const response = await dispatch(deleteContestType(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllContest();
    } catch (error) {}
  };
  useEffect(() => {
    if (editId) {
      const fetchSingleContest = async () => {
        try {
          await dispatch(getSingleContestType(editId));
        } catch (error) {}
      };

      fetchSingleContest();
    }
  }, [dispatch, editId]);

  useEffect(() => {
    if (getSingleContestData) {
      setValues({
        name: getSingleContestData.name,
      });
    }
  }, [getSingleContestData, setValues]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Name",
      key: "name",
    },
  ];
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setEditId(row._id);
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      { label: "S/N", key: "index", render: (_, __, index) => index + 1 },
      {
        label: "Name",
        key: "name",
        render: (_, row) => row?.name || "-",
      },
    ];
    const data = getContestData?.contest_type_data || [];
    exportToTablePDF({
      tableName: "Contest Type Data",
      data,
      headersConfig,
      pdfName: "contest_type_data.pdf",
    });
  };
  return (
    <div>
      <Table
        title="Contest Type"
        buttonTitle="Add Contest Type"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getContestData?.contest_type_data || []}
        actions={actions}
        pageCount={getContestData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Contest Type"
          confirm={confirm}
          onDelete={deleteContestData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <ContestTypeForm
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          onClose={() => {
            setModelOpen(false);
            resetForm();
            setEditId();
          }}
          values={values}
          handleChange={handleChange}
          editId={editId}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </div>
  );
};

export default ContestType;
